import enumTypes from '@/app/library/constants';

export const POPULAR_FILE_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.xls',
  '.xlsx',
  '.txt',
  '.rtf',
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.bmp',
  '.tiff',
  '.tif',
  '.zip',
  '.rar',
  '.7z',
  '.tar',
  '.mp3',
  '.wav',
  '.aac',
  '.mp4',
  '.mov',
  '.avi',
  '.mkv',
  '.html',
  '.htm',
  '.csv',
  '.xml',
];

export const DISCARD_DIALOG = /** @type {const} */ ({
  group: 'global',
  header: 'Discard Changes?',
  message: 'If you leave now, any unsaved changes will be lost.',
  acceptLabel: 'Discard',
  acceptSeverity: 'danger',
});

export const chartScaleLabels = {
  [enumTypes.HOURLY]: 'Hour',
  [enumTypes.DAILY]: 'Day',
  [enumTypes.MONTHLY]: 'Month',
};

export const countries = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Åland Islands' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo, Democratic Republic of the' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: "Côte d'Ivoire" },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands (Malvinas)' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: "Korea, Democratic People's Republic of" },
  { value: 'KR', label: 'Korea, Republic of' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: "Lao People's Democratic Republic" },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MK', label: 'North Macedonia' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine, State of' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Réunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part)' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part)' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
  { value: 'UM', label: 'United States Minor Outlying Islands' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'VG', label: 'Virgin Islands (British)' },
  { value: 'VI', label: 'Virgin Islands (U.S.)' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
];

export const currencies = [
  { value: 'AFN', label: 'Afghanistan - AFN' },
  { value: 'ALL', label: 'Albania - ALL' },
  { value: 'DZD', label: 'Algeria - DZD' },
  { value: 'AOA', label: 'Angola - AOA' },
  { value: 'ARS', label: 'Argentina - ARS' },
  { value: 'AMD', label: 'Armenia - AMD' },
  { value: 'AUD', label: 'Australia - AUD' },
  { value: 'AZN', label: 'Azerbaijan - AZN' },
  { value: 'BHD', label: 'Bahrain - BHD' },
  { value: 'BDT', label: 'Bangladesh - BDT' },
  { value: 'BYN', label: 'Belarus - BYN' },
  { value: 'BZD', label: 'Belize - BZD' },
  { value: 'BMD', label: 'Bermuda - BMD' },
  { value: 'BOB', label: 'Bolivia - BOB' },
  { value: 'BAM', label: 'Bosnia and Herzegovina - BAM' },
  { value: 'BWP', label: 'Botswana - BWP' },
  { value: 'BRL', label: 'Brazil - BRL' },
  { value: 'BND', label: 'Brunei - BND' },
  { value: 'BGN', label: 'Bulgaria - BGN' },
  { value: 'BFA', label: 'Burkina Faso - BFA' },
  { value: 'BIF', label: 'Burundi - BIF' },
  { value: 'KHR', label: 'Cambodia - KHR' },
  { value: 'CAD', label: 'Canada - CAD' },
  { value: 'CVE', label: 'Cape Verde - CVE' },
  { value: 'XAF', label: 'Central African Republic - XAF' },
  { value: 'CLP', label: 'Chile - CLP' },
  { value: 'CNY', label: 'China - CNY' },
  { value: 'COP', label: 'Colombia - COP' },
  { value: 'KMF', label: 'Comoros - KMF' },
  { value: 'CDF', label: 'Congo (Kinshasa) - CDF' },
  { value: 'CRC', label: 'Costa Rica - CRC' },
  { value: 'HRK', label: 'Croatia - HRK' },
  { value: 'CZK', label: 'Czech Republic - CZK' },
  { value: 'DKK', label: 'Denmark - DKK' },
  { value: 'DOP', label: 'Dominican Republic - DOP' },
  { value: 'EGP', label: 'Egypt - EGP' },
  { value: 'ERN', label: 'Eritrea - ERN' },
  { value: 'ETB', label: 'Ethiopia - ETB' },
  { value: 'EUR', label: 'European Union - EUR' },
  { value: 'FJD', label: 'Fiji - FJD' },
  { value: 'GMD', label: 'Gambia - GMD' },
  { value: 'GEL', label: 'Georgia - GEL' },
  { value: 'GHS', label: 'Ghana - GHS' },
  { value: 'GTQ', label: 'Guatemala - GTQ' },
  { value: 'GNF', label: 'Guinea - GNF' },
  { value: 'GYD', label: 'Guyana - GYD' },
  { value: 'HTG', label: 'Haiti - HTG' },
  { value: 'HNL', label: 'Honduras - HNL' },
  { value: 'HKD', label: 'Hong Kong - HKD' },
  { value: 'HUF', label: 'Hungary - HUF' },
  { value: 'ISK', label: 'Iceland - ISK' },
  { value: 'INR', label: 'India - INR' },
  { value: 'IDR', label: 'Indonesia - IDR' },
  { value: 'IRR', label: 'Iran - IRR' },
  { value: 'IQD', label: 'Iraq - IQD' },
  { value: 'ILS', label: 'Israel - ILS' },
  { value: 'JPY', label: 'Japan - JPY' },
  { value: 'JOD', label: 'Jordan - JOD' },
  { value: 'KZT', label: 'Kazakhstan - KZT' },
  { value: 'KES', label: 'Kenya - KES' },
  { value: 'KWD', label: 'Kuwait - KWD' },
  { value: 'KGS', label: 'Kyrgyzstan - KGS' },
  { value: 'LAK', label: 'Laos - LAK' },
  { value: 'LBP', label: 'Lebanon - LBP' },
  { value: 'LSL', label: 'Lesotho - LSL' },
  { value: 'LRD', label: 'Liberia - LRD' },
  { value: 'LYD', label: 'Libya - LYD' },
  { value: 'MOP', label: 'Macau - MOP' },
  { value: 'MKD', label: 'North Macedonia - MKD' },
  { value: 'MGA', label: 'Madagascar - MGA' },
  { value: 'MWK', label: 'Malawi - MWK' },
  { value: 'MYR', label: 'Malaysia - MYR' },
  { value: 'MVR', label: 'Maldives - MVR' },
  { value: 'MRO', label: 'Mauritania - MRO' },
  { value: 'MUR', label: 'Mauritius - MUR' },
  { value: 'MXN', label: 'Mexico - MXN' },
  { value: 'MDL', label: 'Moldova - MDL' },
  { value: 'MNT', label: 'Mongolia - MNT' },
  { value: 'MAD', label: 'Morocco - MAD' },
  { value: 'MZN', label: 'Mozambique - MZN' },
  { value: 'MMK', label: 'Myanmar - MMK' },
  { value: 'NAD', label: 'Namibia - NAD' },
  { value: 'NPR', label: 'Nepal - NPR' },
  { value: 'ANG', label: 'Netherlands Antilles - ANG' },
  { value: 'NZD', label: 'New Zealand - NZD' },
  { value: 'NIO', label: 'Nicaragua - NIO' },
  { value: 'NGN', label: 'Nigeria - NGN' },
  { value: 'KPW', label: 'North Korea - KPW' },
  { value: 'NOK', label: 'Norway - NOK' },
  { value: 'OMR', label: 'Oman - OMR' },
  { value: 'PKR', label: 'Pakistan - PKR' },
  { value: 'PAB', label: 'Panama - PAB' },
  { value: 'PGK', label: 'Papua New Guinea - PGK' },
  { value: 'PYG', label: 'Paraguay - PYG' },
  { value: 'PEN', label: 'Peru - PEN' },
  { value: 'PHP', label: 'Philippines - PHP' },
  { value: 'PLN', label: 'Poland - PLN' },
  { value: 'QAR', label: 'Qatar - QAR' },
  { value: 'RON', label: 'Romania - RON' },
  { value: 'RUB', label: 'Russia - RUB' },
  { value: 'RWF', label: 'Rwanda - RWF' },
  { value: 'SAR', label: 'Saudi Arabia - SAR' },
  { value: 'RSD', label: 'Serbia - RSD' },
  { value: 'SCR', label: 'Seychelles - SCR' },
  { value: 'SLL', label: 'Sierra Leone - SLL' },
  { value: 'SGD', label: 'Singapore - SGD' },
  { value: 'SOS', label: 'Somalia - SOS' },
  { value: 'ZAR', label: 'South Africa - ZAR' },
  { value: 'KRW', label: 'South Korea - KRW' },
  { value: 'SSP', label: 'South Sudan - SSP' },
  { value: 'LKR', label: 'Sri Lanka - LKR' },
  { value: 'SDG', label: 'Sudan - SDG' },
  { value: 'SZL', label: 'Eswatini - SZL' },
  { value: 'SEK', label: 'Sweden - SEK' },
  { value: 'CHF', label: 'Switzerland - CHF' },
  { value: 'SYP', label: 'Syria - SYP' },
  { value: 'TWD', label: 'Taiwan - TWD' },
  { value: 'TJS', label: 'Tajikistan - TJS' },
  { value: 'TZS', label: 'Tanzania - TZS' },
  { value: 'THB', label: 'Thailand - THB' },
  { value: 'TOP', label: 'Tonga - TOP' },
  { value: 'TTD', label: 'Trinidad and Tobago - TTD' },
  { value: 'TND', label: 'Tunisia - TND' },
  { value: 'TRY', label: 'Turkey - TRY' },
  { value: 'TMT', label: 'Turkmenistan - TMT' },
  { value: 'UGX', label: 'Uganda - UGX' },
  { value: 'UAH', label: 'Ukraine - UAH' },
  { value: 'AED', label: 'United Arab Emirates - AED' },
  { value: 'GBP', label: 'United Kingdom - GBP' },
  { value: 'USD', label: 'United States - USD' },
  { value: 'UYU', label: 'Uruguay - UYU' },
  { value: 'UZS', label: 'Uzbekistan - UZS' },
  { value: 'VUV', label: 'Vanuatu - VUV' },
  { value: 'VEF', label: 'Venezuela - VEF' },
  { value: 'VND', label: 'Vietnam - VND' },
  { value: 'YER', label: 'Yemen - YER' },
  { value: 'ZMW', label: 'Zambia - ZMW' },
  { value: 'ZWL', label: 'Zimbabwe - ZWL' },
];

export const paymentTermsOptions = [
  { value: 'DUE_ON_RECEIPT', label: 'Due on Receipt' },
  { value: 'NET_15', label: 'Net 15' },
  { value: 'NET_30', label: 'Net 30' },
  { value: 'NET_45', label: 'Net 45' },
  { value: 'NET_60', label: 'Net 60' },
];

export const IG_AUDIENCE_INDIVIDUAL_METRIC_ERROR_MESSAGE =
  'This metric couldn’t load right now. Try refreshing the page, or check back later.';
